<template>
    <div>
        <kendo-grid
            ref="grid"
            :data-source="TrackingPurchaseOrder"
            :filterable="filterableConfig"
            :sortable="true"
            :pageable="pageableConfig"
            :columns="columns"
            :resizable="true"
        >
        </kendo-grid>
    </div>
</template>
  
  
<script>
import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
import { apiBaseUrl } from '../../../../infrastructure/constant/connection'
import { kendo_grid } from '../../../../infrastructure/constant/variable';
import moment from 'moment';
import TrackingPurchaseOrderServices from '../Script/TrackingPurchaseOrdeService.js';
  
export default {
    name: 'TrackingPurchaseOrderGrid',
    components: {
        'kendo-grid' : Grid,
        'kendo-grid-column': GridColumn,
    },
    props: ['dateTo', 'dateFrom'],
    computed: {
        TrackingPurchaseOrder () {
            var dateFrom = this.$props.dateFrom;
            var dateTo = this.$props.dateTo;
            return new kendo.data.DataSource({
                page: 1,
                pageSize: kendo_grid.default_grid_pagesize,
                serverPaging: false,
                serverFiltering: false,
                serverSorting: false,
                transport: {
                    read: {
                        contentType: "application/json",
                        url: apiBaseUrl,
                        type: "POST",
                        data: function(e) {
                            const variables = {
                                startDate: dateFrom,
                                endDate: dateTo,
                            };
                            return {
                                query: TrackingPurchaseOrderServices.readTrackingPurchaseOrderQuery(),
                                variables: variables
                            };
                        },
                        beforeSend: function (req) {
                            req.setRequestHeader('Authorization', window.$cookies.get('Token'));
                            req.setRequestHeader('Path', window.location.pathname);
                        }
                    },
                    parameterMap: function(options, operation) {
                        return  kendo.stringify({
                            query: options.query,
                            variables: options.variables
                        });
                    },
                    cache: false,
                },
                schema: {
                    data: function (response) {
                        if(response.data.GetReportingTrackingPurchaseOrder == null) {
                            return [];
                        }
                        else {
                            return response.data.GetReportingTrackingPurchaseOrder;
                        }
                    },
                    total: function (response) {
                        if(response.data.GetReportingTrackingPurchaseOrder == null) {
                            return 0;
                        }
                        else {
                            return response.data.GetReportingTrackingPurchaseOrder.length;
                        }
                    },
                    model: {
                        fields: {
                            purchase_order_date: {type: "date"},
                        }
                    }
                },
            });
        }
    },
    data: function () {
        return  {
            columns:  [
                { field: "purchase_order_number", title: "No. PO", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, },
                { field: "purchase_order_date", title: "Tanggal PO", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, attributes:{style: "text-align:center;"},
                    template: "#= kendo.toString(kendo.parseDate(purchase_order_date, 'yyyy-MM-dd'), 'dd-MM-yyyy') #",
                    filterable : {
                        ui: function (element) {
                            element.kendoDatePicker({
                                format: "yyyy-MM-dd"
                            });
                        }
                    } 
                },
                { field: "project_name", title: "Project", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, },
                { field: "customer_name", title: "Customer", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, },
                { field: "invoice_numbers", title: "No. Bukti", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, },
                { field: "delivery_order_numbers", title: "No. DO", width: 200, headerAttributes:{ style: "text-align:center; font-weight:bold;" }, },
            ],
            filterableConfig:  {
                extra: true,
                operators: kendo_grid.client_operator
            },
            pageableConfig: kendo_grid.default_pageable_config
        };
    },
    mounted: async function() {
    },
    methods: {
        async exportExcel(DateFrom, DateTo) {
            const variables = {
                startDate: DateFrom,
                endDate: DateTo
            };

            var gridData = this.$refs.grid.kendoWidget()._data;
            var data = await TrackingPurchaseOrderServices.trackingPurchaseOrderExcel(gridData, variables);
            if (gridData == null) {
                this.$swal("Error", response.noRecord, "error")
            }
            else {
                var XLSX = require("xlsx");
                var dateNow = moment(new Date()).format("YYYY-MM-DD-HHmmss");

                var filename = 'Tracking_Purchase_order_' + dateNow + '.xlsx';
                var ws = XLSX.utils.json_to_sheet(data, {skipHeader: true});
                ws['!cols'] = TrackingPurchaseOrderServices.trackingPurchaseOrderExcelHeaderSize();

                var wb = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(wb, ws);
                XLSX.writeFile(wb, filename);
            }
        },
    },
}
</script>